import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AdminForm from "./AdminForm";
import apiClient from "../../utils/apiClient";
import CommonToaster from "../Common/CommonToaster";

const AddAdminPage = () => {
  const [loading, setLoading] = useState(false);
  const [admins, setAdmins] = useState([]);
  const [toast, setToast] = useState({ show: false, message: "", type: "success" });
  const navigate = useNavigate();

  // Fetch admins list for reporting manager dropdown
  useEffect(() => {
    apiClient.get("/admins/list").then(({ data }) => setAdmins(data.admins || [])).catch(() => {});
  }, []);

  const handleRegisterAdmin = async (form) => {
    setLoading(true);
    try {
      const { data } = await apiClient.post("/admins/add", form);
      setToast({ show: true, message: data.message, type: "success" });
      setTimeout(() => navigate("/admins"), 1000);
    } catch (err) {
      setToast({
        show: true,
        message: err?.response?.data?.message || "Failed to register admin.",
        type: "error",
      });
    }
    setLoading(false);
  };

  return (
    <>
      <AdminForm
        onSubmit={handleRegisterAdmin}
        loading={loading}
        onCancel={() => navigate("/admins")}
        admins={admins}
      />
      <CommonToaster
        show={toast.show}
        message={toast.message}
        type={toast.type}
        onClose={() => setToast((t) => ({ ...t, show: false }))}
      />
    </>
  );
};

export default AddAdminPage;
